import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { IProfession } from 'src/app/shared/interfaces/profession/iprofession';
import { ModalService } from 'src/app/shared/services/modal.service';
import {
  editProfession,
  loadProfession,
} from 'src/app/store/profession/profession.actions';
import { selectProfessionLista } from 'src/app/store/profession/profession.selectors';

@Component({
  selector: 'app-dados-profissoes-form',
  templateUrl: './dados-profissoes-form.component.html',
  styleUrls: ['./dados-profissoes-form.component.scss'],
})
export class DadosProfissoesFormComponent {
  constructor(
    private fb: FormBuilder,
    private ref: DynamicDialogRef,
    private modalService: ModalService,
    private store: Store<IProfession>,
    private config: DynamicDialogConfig
  ) {}

  ngOnInit(): void {
    this.store.dispatch(loadProfession());
    if (this.config.data && this.config.data.item) {
      //this.id = this.config.data.item.id;
      //this.popularFormulario(this.config.data.item);
      this.profissao = this.config.data.item;
    }
  }

  profissao: IProfession | null = null;
  lista$ = this.store.select(selectProfessionLista);

  //modal functions

  changeTitle(index: number) {
    if (index == 0) {
      this.modalService.changeHeader('Adicionar profissão:');
    } else {
      this.modalService.changeHeader('Especialidades:');
    }
  }
  disableCard(dado: any) {
    let item = { ...dado };
    item.enable = !item.enable;
    let profissao: IProfession = { ...this.profissao } as IProfession;
    profissao.specialties = profissao.specialties.map((spec) => {
      if (spec.id == item.id) {
        return item;
      } else {
        return spec;
      }
    });
    this.profissao = { ...profissao } as IProfession;
    // console.log(profissao);
    // this.saveProfission
  }

  disableService(dado: any) {
    let item = { ...dado };
    item.enable = !item.enable;
    let profissao: IProfession = { ...this.profissao } as IProfession;
    profissao.specialties = profissao.specialties.map((spec) => {
      return {
        ...spec,
        service: spec.service.map((obj) => {
          if (obj.id == item.id) {
            return item;
          } else {
            return obj;
          }
        }),
      };
    });
    this.profissao = { ...profissao } as IProfession;
  }

  saveProfission() {
    // event.stopPropagation();
    this.store.dispatch(
      editProfession({
        profession: this.profissao as IProfession,
        id: (this.profissao as IProfession).id as number,
      })
    );
  }
  saveForm() {
    this.saveProfission();
    this.closeForm();
  }
  closeForm() {
    this.ref.close();
  }
}
